export const albumApiData = {
  'albumTypeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专辑类别'],
    title: '获取专辑类别', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑类别', url: '/api/v1/invoke/album/categroy', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '类别id' },
        { paras: 'name', type: 'String', description: '类别名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 20,
        "createdTime": "2023-04-03T14:13:11",
        "modifiedTime": "2023-04-03T14:13:11",
        "name": "同步备课",
        "stageId": 3,
        "type": "style",
        "ordinal": 1
      }]
    }
    `
  },
  'albumVersionList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专辑版本'],
    title: '获取专辑版本', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑版本', url: '/api/v1/invoke/album/versions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '版本id' },
        { paras: 'name', type: 'String', description: '版本名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 742,
        "name": "统编版",
        "bookFlag": 1
      }]
    }
    `
  },
  'albumTextbookList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专辑册别'],
    title: '获取专辑册别', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑册别', url: '/api/v1/invoke/album/textbooks', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'versionId', type: 'Int', required: '必填', description: '版本id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '册别id' },
        { paras: 'name', type: 'String', description: '册别名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 798,
        "name": "必修1"
      }, {
        "id": 799,
        "name": "必修2"
      }]
    }
    `
  },
  'albumReviewSectionList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取复习段'],
    title: '获取复习段', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取复习段', url: '/api/v1/invoke/album/reviewSection', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '复习段id' },
        { paras: 'name', type: 'String', description: '复习段名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 38,
        "createdTime": "2023-04-03T14:13:48",
        "modifiedTime": "2023-04-03T14:13:48",
        "name": "一轮",
        "stageId": 4,
        "type": "reviewSection",
        "ordinal": 1
      }]
    }
    `
  },
  'albumCatalogList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', ' 获取资源类型'],
    title: ' 获取资源类型', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取资源类型', url: '/api/v1/invoke/album/resourceCategory', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '资源类别id' },
        { paras: 'name', type: 'String', description: '资源类别名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 41,
        "createdTime": "2023-04-03T14:13:50",
        "modifiedTime": "2023-04-03T14:13:50",
        "name": "课件",
        "stageId": null,
        "type": "resourceCategory",
        "ordinal": 1
      }]
    }
    `
  },
  'albumTopicList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专题列表'],
    title: '获取专题列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专题列表', url: '/api/v1/invoke/album/resourcePages', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
        { paras: 'classTypeId', type: 'Int', required: '非必填', description: '类别id' },
        { paras: 'name', type: 'String', required: '非必填', description: '检索关键词' },
        { paras: 'sourceId', type: 'Int', required: '非必填', description: '来源，默认为空' },
        { paras: 'orderBy', type: 'Int', required: '必填', description: '排序方式，1为最新，2为浏览最多', option: [1, 2] },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '每页条数' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专题id' },
        { paras: 'name ', type: 'String', description: '专题名称' },
        { paras: 'author ', type: 'String', description: '专题作者' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'createdTime ', type: 'String', description: '创建时间' },
        { paras: 'intro ', type: 'String', description: '专题介绍' },
        { paras: 'versionList ', type: 'Array', description: '专题版本' },
        { paras: 'albumResourceCount ', type: 'Int', description: '专辑数' },
        { paras: 'fileAddress ', type: 'String', description: '专题缩略图' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "content": [
              {
                  "id": 51,
                  "createdTime": "2023-04-23 09:54:50",
                  "modifiedTime": "2023-05-26 10:24:39",
                  "updateTime": "2023-04-20 17:16:09",
                  "name": "【九科精测】2022-2023学年初中阶段性检测卷",
                  "stageId": 3,
                  "stageName": null,
                  "subjectList": null,
                  "classTypeId": "21",
                  "classTypeName": null,
                  "sourceId": 33,
                  "sourceName": "精品团队",
                  "intro": "九科精品测试卷",
                  "fileAddress": "https://jty-nrsc-album.obs.cn-north-4.myhuaweicloud.com/168200952593458003743",
                  "author": "XXX",
                  "albumResourceCount": 0,
                  "versionList": [],
                  "useStatus": 1
              }
          ],
          "pageable": {
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "pageSize": 10,
              "pageNumber": 0,
              "offset": 0,
              "paged": true,
              "unpaged": false
          },
          "last": true,
          "totalElements": 1,
          "totalPages": 1,
          "first": true,
          "sort": {
              "sorted": true,
              "unsorted": false
          },
          "numberOfElements": 1,
          "size": 10,
          "number": 0
      }
    }
    `
  },
  'albumTopicAlbum': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专题下专辑'],
    title: '获取专题下专辑', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专题下专辑', url: '/api/v1/invoke/album/albumPages', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'specialTopicId', type: 'Int', required: '必填', description: '专题id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '每页条数' },
        { paras: 'ifNewestOrMost', type: 'String', required: '必填', description: '排序方式，newest最新，most最热', option: ['newest', 'most'] }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专辑id' },
        { paras: 'name ', type: 'String', description: '专辑名称' },
        { paras: 'author ', type: 'String', description: '专辑作者' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'classTypeId ', type: 'Int', description: '类别id' },
        { paras: 'intro ', type: 'String', description: '专辑简介' },
        { paras: 'specialTopicId ', type: 'String', description: '所属专题' },
        { paras: 'provinces ', type: 'Array', description: '省份' },
        { paras: 'documentCount ', type: 'Int', description: '文档数' },
        { paras: 'downloadCount ', type: 'Int', description: '下载量' },
        { paras: 'viewCount ', type: 'Int', description: '浏览量' },
        { paras: 'fileAddress ', type: 'String', description: '专题缩略图' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "content": [
              {
                  "id": 200183,
                  "name": "精品专辑-高中语文-同步测评-统编版-选择性必修上中下",
                  "stageId": 4,
                  "stageName": "高中",
                  "subjectId": null,
                  "moduleId": null,
                  "moduleName": null,
                  "versionId": null,
                  "versionName": null,
                  "intro": "123456",
                  "fileAddress": "https://jty-nrsc-album.obs.cn-north-4.myhuaweicloud.com/168501143743718843496",
                  "status": 0,
                  "modifiedTime": "2023-07-28",
                  "updateTime": "2023-07-24",
                  "viewCount": 4,
                  "downloadCount": 234,
                  "documentCount": 12,
                  "author": "XXX",
                  "uid": 124,
                  "classTypeId": 31,
                  "classTypeName": "同步测评",
                  "originId": 33,
                  "origin": "精品团队",
                  "year": 2023,
                  "reviewSectionId": null,
                  "reviewSectionName": null,
                  "specialTopicId": 21,
                  "specialTopicName": "高中九科--同步测评-精品团队专题006-发神经咖啡机弗利萨打了分类撒娇了法律是大忌了发啦山东",
                  "textbooks": [
                      {
                          "basicVersionId": 742,
                          "basicVersionName": "统编版",
                          "textbookId": 5087,
                          "textbookName": "选择性必修上册"
                      },
                      {
                          "basicVersionId": 742,
                          "basicVersionName": "统编版",
                          "textbookId": 5088,
                          "textbookName": "选择性必修中册"
                      },
                      {
                          "basicVersionId": 742,
                          "basicVersionName": "统编版",
                          "textbookId": 5089,
                          "textbookName": "选择性必修下册"
                      }
                  ],
                  "subjects": [
                      {
                          "id": 26,
                          "name": "语文"
                      }
                  ],
                  "resourceCategorys": [],
                  "provinces": [
                      {
                          "id": 110000,
                          "name": "北京"
                      },
                      {
                          "id": 120000,
                          "name": "天津"
                      }
                  ],
                  "linkList": [
                      {
                          "linkId": null,
                          "catalogueId": null,
                          "albumResourceId": null,
                          "documentId": 8907614,
                          "name": "测试2",
                          "suffixType": null,
                          "downloadIntegral": null,
                          "updateTime": null,
                          "size": null,
                          "ordinal": null,
                          "download": null,
                          "downloadNum": null,
                          "viewNum": null
                      },
                      {
                          "linkId": null,
                          "catalogueId": null,
                          "albumResourceId": null,
                          "documentId": 8907613,
                          "name": "提现数据",
                          "suffixType": null,
                          "downloadIntegral": null,
                          "updateTime": null,
                          "size": null,
                          "ordinal": null,
                          "download": null,
                          "downloadNum": null,
                          "viewNum": null
                      },
                      {
                          "linkId": null,
                          "catalogueId": null,
                          "albumResourceId": null,
                          "documentId": 8907442,
                          "name": "初中历史11版课标与22年课标对比",
                          "suffixType": null,
                          "downloadIntegral": null,
                          "updateTime": null,
                          "size": null,
                          "ordinal": null,
                          "download": null,
                          "downloadNum": null,
                          "viewNum": null
                      }
                  ],
                  "collection": false
              },
          ],
          "pageable": {
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "pageSize": 10,
              "pageNumber": 0,
              "offset": 0,
              "paged": true,
              "unpaged": false
          },
          "last": true,
          "totalElements": 5,
          "totalPages": 1,
          "first": true,
          "sort": {
              "sorted": true,
              "unsorted": false
          },
          "numberOfElements": 5,
          "size": 10,
          "number": 0
      }
    }`
  },
  'albumTopicInfo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专题基本信息'],
    title: '获取专题基本信息', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑册别', url: '/api/v1/invoke/album/topicResource/detail', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'id', type: 'Int', required: '必填', description: '专题id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专题id' },
        { paras: 'name ', type: 'String', description: '专题名称' },
        { paras: 'author ', type: 'String', description: '专题作者' },
        { paras: 'classTypeId ', type: 'Int', description: '类别id' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'createdTime ', type: 'String', description: '创建时间' },
        { paras: 'intro ', type: 'String', description: '专题介绍' },
        { paras: 'versionList ', type: 'Array', description: '专题版本' },
        { paras: 'albumResourceCount ', type: 'Int', description: '专辑数' },
        { paras: 'fileAddress ', type: 'String', description: '专题缩略图' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "id": 21,
          "createdTime": "2023-07-24 08:52:29",
          "modifiedTime": "2023-08-01 08:30:05",
          "updateTime": "2023-07-24 08:52:31",
          "name": "高中九科--同步测评-精品团队专题006-发神经咖啡机弗利萨打了分类撒娇了法律是大忌了发啦山东",
          "stageId": 4,
          "stageName": null,
          "subjectList": null,
          "classTypeId": "31",
          "classTypeName": null,
          "sourceId": 33,
          "sourceName": "精品团队",
          "intro": "-法发顺丰高中九科--同步测评-精品团队专题006-发神经咖啡机弗利萨打了分类撒娇了法律是大忌了发啦山东",
          "fileAddress": "https://jty-nrsc-album.obs.cn-north-4.myhuaweicloud.com/168122988632599880020",
          "author": "XXX",
          "albumResourceCount": 5,
          "versionList": [
              {
                  "id": 0,
                  "createdTime": null,
                  "modifiedTime": null,
                  "name": "不限",
                  "description": null,
                  "year": null,
                  "ordinal": null,
                  "used": null,
                  "subjectId": null,
                  "basicDocumentStatus": null,
                  "bookFlag": null
              },
              {
                  "id": 313,
                  "createdTime": "2018-08-03T22:58:46",
                  "modifiedTime": "2023-04-25T09:26:38",
                  "name": "北师大版",
                  "description": "",
                  "year": 2005,
                  "ordinal": 8,
                  "used": true,
                  "subjectId": 26,
                  "basicDocumentStatus": 0,
                  "bookFlag": 0
              },
              {
                  "id": 315,
                  "createdTime": "2018-08-03T22:58:47",
                  "modifiedTime": "2023-04-25T09:26:38",
                  "name": "京改版",
                  "description": "",
                  "year": 2006,
                  "ordinal": 10,
                  "used": true,
                  "subjectId": 26,
                  "basicDocumentStatus": 0,
                  "bookFlag": 0
              },
              {
                  "id": 317,
                  "createdTime": "2018-08-03T22:58:47",
                  "modifiedTime": "2023-04-25T09:26:39",
                  "name": "鲁人版",
                  "description": "网上称呼的鲁教版就是鲁人版。山东教育出版社没有高中语文教材。",
                  "year": 2004,
                  "ordinal": 11,
                  "used": true,
                  "subjectId": 26,
                  "basicDocumentStatus": 0,
                  "bookFlag": 0
              },
              {
                  "id": 318,
                  "createdTime": "2018-08-03T22:58:48",
                  "modifiedTime": "2023-04-25T09:26:39",
                  "name": "人教版",
                  "description": "",
                  "year": 2004,
                  "ordinal": 6,
                  "used": true,
                  "subjectId": 26,
                  "basicDocumentStatus": 0,
                  "bookFlag": 1
              },
              {
                  "id": 742,
                  "createdTime": "2020-03-14T10:30:46",
                  "modifiedTime": "2022-12-12T14:53:17",
                  "name": "统编版",
                  "description": "",
                  "year": null,
                  "ordinal": 0,
                  "used": true,
                  "subjectId": 26,
                  "basicDocumentStatus": 1,
                  "bookFlag": 1
              },
              {
                  "id": 744,
                  "createdTime": "2020-04-02T08:51:30",
                  "modifiedTime": "2022-06-25T09:23:15",
                  "name": "人教版2019",
                  "description": null,
                  "year": null,
                  "ordinal": 0,
                  "used": true,
                  "subjectId": 29,
                  "basicDocumentStatus": 1,
                  "bookFlag": 1
              }
          ],
          "useStatus": 1
      }
  }
    `
  },
  'albumAlbumList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专辑列表'],
    title: '获取专辑列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑列表', url: '/api/v1/invoke/album/albumPages', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科' },
        { paras: 'name', type: 'String', required: '非必填', description: '检索词' },
        { paras: 'classTypeId', type: 'Int', required: '非必填', description: '类别' },
        { paras: 'versionId', type: 'Int', required: '非必填', description: '版本' },
        { paras: 'textbookIds', type: 'Int', required: '非必填', description: '册别' },
        { paras: 'year', type: 'Int', required: '非必填', description: '届别' },
        { paras: 'resourceCategoryId', type: 'Int', required: '非必填', description: '资源类型' },
        { paras: 'reviewSectionId', type: 'Int', required: '非必填', description: '复习段' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '每页条数' },
        { paras: 'ifNewestOrMost', type: 'Int', required: '必填', description: '排序 newest 最新 most 最多', option: ['newest', 'most'] },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专辑id' },
        { paras: 'name ', type: 'String', description: '专辑名称' },
        { paras: 'author ', type: 'String', description: '专辑作者' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'classTypeId ', type: 'Int', description: '类别id' },
        { paras: 'intro ', type: 'String', description: '专辑简介' },
        { paras: 'specialTopicId ', type: 'String', description: '所属专题' },
        { paras: 'provinces ', type: 'Array', description: '省份' },
        { paras: 'documentCount ', type: 'Int', description: '文档数' },
        { paras: 'downloadCount ', type: 'Int', description: '下载量' },
        { paras: 'viewCount ', type: 'Int', description: '浏览量' },
        { paras: 'fileAddress ', type: 'String', description: '专题缩略图' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "content": [
              {
                  "id": 200148,
                  "name": "名师课堂",
                  "stageId": 4,
                  "stageName": "高中",
                  "subjectId": null,
                  "moduleId": null,
                  "moduleName": null,
                  "versionId": null,
                  "versionName": null,
                  "intro": "同步课件",
                  "fileAddress": "https://jty-nrsc-album.obs.cn-north-4.myhuaweicloud.com/168200079020703081551",
                  "status": 0,
                  "modifiedTime": "2023-07-19",
                  "updateTime": "2023-05-26",
                  "viewCount": 62,
                  "downloadCount": 228,
                  "documentCount": 10,
                  "author": "XXX",
                  "uid": 119,
                  "classTypeId": 30,
                  "classTypeName": "同步备课",
                  "originId": 33,
                  "origin": "精品团队",
                  "year": 2023,
                  "reviewSectionId": null,
                  "reviewSectionName": null,
                  "specialTopicId": 47,
                  "specialTopicName": "测试龚飞飞",
                  "textbooks": [
                      {
                          "basicVersionId": 0,
                          "basicVersionName": "不限",
                          "textbookId": 0,
                          "textbookName": "不限"
                      }
                  ],
                  "subjects": [
                      {
                          "id": 26,
                          "name": "语文"
                      },
                      {
                          "id": 27,
                          "name": "数学"
                      },
                      {
                          "id": 28,
                          "name": "英语"
                      },
                      {
                          "id": 29,
                          "name": "物理"
                      },
                      {
                          "id": 30,
                          "name": "化学"
                      },
                      {
                          "id": 31,
                          "name": "生物"
                      },
                      {
                          "id": 32,
                          "name": "政治"
                      },
                      {
                          "id": 33,
                          "name": "历史"
                      },
                      {
                          "id": 34,
                          "name": "地理"
                      }
                  ],
                  "resourceCategorys": [
                      {
                          "id": 41,
                          "name": "课件"
                      }
                  ],
                  "provinces": [
                      {
                          "id": 2,
                          "name": "全国"
                      }
                  ],
                  "linkList": [
                      {
                          "linkId": null,
                          "catalogueId": null,
                          "albumResourceId": null,
                          "documentId": 8907057,
                          "name": "组卷全过程体验反馈",
                          "suffixType": null,
                          "downloadIntegral": null,
                          "updateTime": null,
                          "size": null,
                          "ordinal": null,
                          "download": null,
                          "downloadNum": null,
                          "viewNum": null
                      },
                      {
                          "linkId": null,
                          "catalogueId": null,
                          "albumResourceId": null,
                          "documentId": 8907055,
                          "name": "2023年02月17日试卷",
                          "suffixType": null,
                          "downloadIntegral": null,
                          "updateTime": null,
                          "size": null,
                          "ordinal": null,
                          "download": null,
                          "downloadNum": null,
                          "viewNum": null
                      },
                      {
                          "linkId": null,
                          "catalogueId": null,
                          "albumResourceId": null,
                          "documentId": 8907056,
                          "name": "精品解析：河北省石家庄市第二中学2022-2023学年高三下学期开学考试地理试题-2",
                          "suffixType": null,
                          "downloadIntegral": null,
                          "updateTime": null,
                          "size": null,
                          "ordinal": null,
                          "download": null,
                          "downloadNum": null,
                          "viewNum": null
                      }
                  ],
                  "collection": false
              }
          ],
          "pageable": {
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "pageSize": 10,
              "pageNumber": 0,
              "offset": 0,
              "paged": true,
              "unpaged": false
          },
          "last": true,
          "totalElements": 1,
          "totalPages": 1,
          "first": true,
          "sort": {
              "sorted": true,
              "unsorted": false
          },
          "numberOfElements": 1,
          "size": 10,
          "number": 0
      }
  }
    `
  },
  'albumAlbumDoc': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专辑文档'],
    title: '获取专辑文档', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑文档', url: '/api/v1/invoke/album/resourceLinks', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'albumId', type: 'Int', required: '必填', description: '专辑id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'catalogueName', type: 'String', description: '目录名称' },
        { paras: 'resourceLinkS', type: 'Array', description: '目录下文档' },
        { paras: 'resourceLinkS/documentId', type: 'Int', description: '文档id' },
        { paras: 'resourceLinkS/name', type: 'String', description: '文档名称' },
        { paras: 'resourceLinkS/suffixType', type: 'String', description: '文档格式' },
        { paras: 'resourceLinkS/size', type: 'Int', description: '文档大小kb' }
      ],
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "id": null,
          "parentId": null,
          "albumId": null,
          "ordinal": null,
          "catalogueName": "全部",
          "depth": null,
          "children": [
              {
                  "id": 1366,
                  "parentId": 0,
                  "albumId": 200183,
                  "ordinal": 0,
                  "catalogueName": "范德萨发",
                  "depth": 1,
                  "children": [
                      {
                          "id": 1367,
                          "parentId": 1366,
                          "albumId": 200183,
                          "ordinal": 0,
                          "catalogueName": "VS发多少",
                          "depth": 2,
                          "children": [],
                          "resourceLinkS": [
                              {
                                  "linkId": 100695,
                                  "catalogueId": 1367,
                                  "albumResourceId": 200183,
                                  "documentId": 8906065,
                                  "name": "1226wwk测试试卷2",
                                  "suffixType": "docx",
                                  "downloadIntegral": 10,
                                  "updateTime": "2022-12-26",
                                  "size": 9,
                                  "ordinal": 877,
                                  "download": 0,
                                  "downloadNum": 18,
                                  "viewNum": 21
                              }
                          ]
                      }
                  ],
                  "resourceLinkS": [
                      {
                          "linkId": 100697,
                          "catalogueId": 1366,
                          "albumResourceId": 200183,
                          "documentId": 8905769,
                          "name": "优选卷库测试122数据",
                          "suffixType": "doc",
                          "downloadIntegral": 45,
                          "updateTime": "2022-12-03",
                          "size": 10,
                          "ordinal": 879,
                          "download": 0,
                          "downloadNum": 28,
                          "viewNum": 16
                      },
                  ]
              }
          ],
          "resourceLinkS": [
              {
                  "linkId": 100689,
                  "catalogueId": 0,
                  "albumResourceId": 200183,
                  "documentId": 8907318,
                  "name": "2023年04月21日试卷 (2)",
                  "suffixType": "docx",
                  "downloadIntegral": 0,
                  "updateTime": "2023-06-29",
                  "size": 256,
                  "ordinal": 899,
                  "download": 0,
                  "downloadNum": 17,
                  "viewNum": 12
              },
          ]
      }
  }
    `
  },
  'albumAlbumInfo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '获取专辑基本信息'],
    title: '获取专辑基本信息', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取专辑基本信息', url: '/api/v1/invoke/album/getAlbumInfo', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'albumId', type: 'Int', required: '必填', description: '专辑id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '专辑id' },
        { paras: 'name ', type: 'String', description: '专辑名称' },
        { paras: 'subjects ', type: 'Array', description: '学科' },
        { paras: 'textbooks ', type: 'Array', description: '册别' },
        { paras: 'provinces ', type: 'Array', description: '省份' },
        { paras: 'author ', type: 'String', description: '专辑作者' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'classTypeId ', type: 'Int', description: '类别id' },
        { paras: 'intro ', type: 'String', description: '专辑简介' },
        { paras: 'specialTopicId ', type: 'String', description: '所属专题' },
        { paras: 'provinces ', type: 'Array', description: '省份' },
        { paras: 'documentCount ', type: 'Int', description: '文档数' },
        { paras: 'downloadCount ', type: 'Int', description: '下载量' },
        { paras: 'viewCount ', type: 'Int', description: '浏览量' },
        { paras: 'fileAddress ', type: 'String', description: '专题缩略图' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "id": 200148,
          "name": "名师课堂",
          "stageId": 4,
          "stageName": "高中",
          "subjectId": null,
          "moduleId": null,
          "moduleName": null,
          "versionId": null,
          "versionName": null,
          "intro": "同步课件",
          "fileAddress": "https://jty-nrsc-album.obs.cn-north-4.myhuaweicloud.com/168200079020703081551",
          "status": 0,
          "modifiedTime": "2023-07-19",
          "updateTime": "2023-05-26",
          "viewCount": 62,
          "downloadCount": 228,
          "documentCount": 10,
          "author": "XXX",
          "uid": 119,
          "classTypeId": 30,
          "classTypeName": "同步备课",
          "originId": 33,
          "origin": "精品团队",
          "year": 2023,
          "reviewSectionId": null,
          "reviewSectionName": null,
          "specialTopicId": 47,
          "specialTopicName": "测试龚飞飞",
          "textbooks": [
              {
                  "basicVersionId": 0,
                  "basicVersionName": "不限",
                  "textbookId": 0,
                  "textbookName": "不限"
              }
          ],
          "subjects": [
              {
                  "id": 26,
                  "name": "语文"
              },
              {
                  "id": 27,
                  "name": "数学"
              },
              {
                  "id": 28,
                  "name": "英语"
              },
              {
                  "id": 29,
                  "name": "物理"
              },
              {
                  "id": 30,
                  "name": "化学"
              },
              {
                  "id": 31,
                  "name": "生物"
              },
              {
                  "id": 32,
                  "name": "政治"
              },
              {
                  "id": 33,
                  "name": "历史"
              },
              {
                  "id": 34,
                  "name": "地理"
              }
          ],
          "resourceCategorys": [
              {
                  "id": 41,
                  "name": "课件"
              }
          ],
          "provinces": [
              {
                  "id": 2,
                  "name": "全国"
              }
          ],
          "linkList": null,
          "collection": false
      }
  }
    `
  },
  'albumAlbumPreview': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '专辑文档预览'],
    title: '专辑文档预览', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '专辑文档预览', url: '/api/v1/invoke/album/preview', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Int', required: '必填', description: '文档id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'data ', type: 'Array', description: '图片数据，zip资料长度为zip内文档数量，非zip文档长度为1，空数组表示未解压或未转码文档' },
        { paras: 'status ', type: 'String', description: '是否完成转换为图片，Finished表示完成转换，其他表示转码中' },
        { paras: 'pictureUrls ', type: 'Array', description: '文档图片地址' },
        { paras: 'picsCount ', type: 'Int', description: '文档图片总数量' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": [
              {
                  "documentId": 8906328,
                  "id": 1800,
                  "type": null,
                  "size": 1092,
                  "suffixType": "pptx",
                  "fileAddress": "{%uploaddir%}unzipFile/20230302-1677722209700l98lqdib/小学-北师大版2001二年级上册同步备课1204-01.pptx",
                  "status": "Finished",
                  "pictureUrls": [
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/1.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=Qg%2FYtjv4HxYr9a4JEWl8Akskizw%3D",
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/2.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=OzkFfPdEYT5nx4mOO8uAdh6Beog%3D",
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/3.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=TAkJCUfggK66rI1DHFiHPlD3JzM%3D"
                  ],
                  "isAllPics": false,
                  "picsCount": 42
              },
              {
                  "documentId": 8906328,
                  "id": 1801,
                  "type": null,
                  "size": 10,
                  "suffixType": "doc",
                  "fileAddress": "{%uploaddir%}unzipFile/20230302-1677722209700l98lqdib/优选卷库测试122数据.doc",
                  "status": "Finished",
                  "pictureUrls": [],
                  "isAllPics": false,
                  "picsCount": 1
              },
              {
                  "documentId": 8906328,
                  "id": 1802,
                  "type": null,
                  "size": 267,
                  "suffixType": "pptx",
                  "fileAddress": "{%uploaddir%}unzipFile/20230302-1677722209700l98lqdib/专训卷八.pptx",
                  "status": "Finished",
                  "pictureUrls": [
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E4%B8%93%E8%AE%AD%E5%8D%B7%E5%85%AB/1.png?Expires=1684981458&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=73OLPg45W61KC1p41KUOeS14pJo%3D",
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E4%B8%93%E8%AE%AD%E5%8D%B7%E5%85%AB/2.png?Expires=1684981458&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=BA0RH6OCPIOV7Bmx6gZqel1sOFQ%3D",
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E4%B8%93%E8%AE%AD%E5%8D%B7%E5%85%AB/3.png?Expires=1684981458&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=pM3yrb55pl3V6AlyKh9kKKN3lIs%3D"
                  ],
                  "isAllPics": false,
                  "picsCount": 28
              }
          ]
      }
    `
  },
  'albumAlbumDownload': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '专辑资源', '专辑文档下载'],
    title: '专辑文档下载', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '专辑文档下载', url: '/api/v1/invoke/album/download', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Int', required: '必填', description: '文档id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'data', type: 'String', required: '必填', description: '文档url' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": "https://jty-document-new.obs.cn-north-4.myhuaweicloud.com/2022/12/26/1672041805258h6uej94dt8.doc?Expires=1678602377&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=%2FLNHDV8nRzh1jwB9W4Wnv7jfln8%3D&response-content-disposition=%20attachment%3B%20filename%3D%22%C3%A9%C2%AB%C2%98%C3%A4%C2%B8%C2%AD%C3%A8%C2%AF%C2%AD%C3%A6%C2%96%C2%87%C3%A9%C2%AB%C2%98%C3%A8%C2%80%C2%83%C3%A4%C2%B8%C2%93%C3%A5%C2%8C%C2%BA%C3%A5%C2%91%C2%A8%C3%A6%C2%B5%C2%8B%C3%A5%C2%8D%C2%B7%C3%A4%C2%BA%C2%BA%C3%A6%C2%95%C2%99%C3%A7%C2%89%C2%88%C3%A7%C2%AC%C2%AC%C3%A5%C2%8D%C2%81%C3%A4%C2%B8%C2%80%C3%A7%C2%AB%C2%A0%20%C3%A5%C2%90%C2%8D%C3%A5%C2%8F%C2%A5%C3%A5%C2%90%C2%8D%C3%A7%C2%AF%C2%87%C3%A9%C2%BB%C2%98%C3%A5%C2%86%C2%99.doc%22&response-content-type=application%2Fmsword"
    }
    `
  },
}



// WEBPACK FOOTER //
// ./src/pages/front/document/albumApiData.js